export function getCSRFToken(): string {
  const meta = document.querySelector('meta[name="csrf-token"]');
  return meta ? meta.getAttribute('content') || '' : '';
}

export async function getHttpResponse(
  method: string,
  url: string,
  body?: Record<string, any>
): Promise<Response> {
  const init: RequestInit = {
    method,
    headers: {
      Accept: 'application/json',
      'X-CSRF-Token': getCSRFToken(),
    },
  };

  // Only attach JSON headers + body when body is provided
  if (body !== undefined) {
    (init.headers as Record<string, string>)['Content-Type'] = 'application/json';
    init.body = JSON.stringify(body);
  }

  return fetch(url, init);
}

export function getCookie(name: string): string | undefined {
  if (typeof document === 'undefined') return undefined;
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  if (match) return decodeURIComponent(match[2]);
}

export function navigateToUi(rawPath: string) {
  const trimmed = String(rawPath || '').replace(/^\/+/, '');
  const url = `/dash/${trimmed}`;

  // If Turbo is present (Rails 7+/8 default), use it for fast navigation
  const turbo = (window as any).Turbo;
  if (turbo && typeof turbo.visit === 'function') {
    turbo.visit(url);
    return;
  }

  // Fallback: full page navigation
  window.location.assign(url);
}
